<template>
    <v-dialog :width="width" v-model="active" transition="dialog-bottom-transition" @click:outside.stop="closeModal()"
        :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card>
            <v-card-title class="pa-0">
                <v-toolbar dark :color="color">
                    <v-toolbar-title>
                        <p class="mb-0">{{ title }}</p>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="closeModal()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
            </v-card-title>
            <v-card-text>
                <slot />
            </v-card-text>
            <v-card-actions v-if="actions">
                <v-spacer></v-spacer>
                <v-btn color="danger darken-1" text @click="closeModal()">
                    Annuleren
                </v-btn>
                <v-btn :color="color" text @click="$emit('clickPrimaryAction')">
                    {{ primaryActionText }}
                </v-btn>
            </v-card-actions>
            <div v-if="$slots.actions" class="card-footer">
                <slot name="actions" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "BaseModal",
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: false,
            default: "700"
        },
        actions: {
            type: Boolean,
            default: false
        },
        primaryActionText: {
            type: String,
            default: "Verder"
        },
        color: {
            type: String,
            default: "primary"
        },
    },
    emits: ['closeModal', 'clickPrimaryAction'],
    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
    }
}
</script>